export default "__VITE_ASSET__nfm0CYlg__"